import { SearchIcon } from "@cynthai/icons";
import { twMerge } from "tailwind-merge";

import type { InputProps } from "./Input";
import Input from "./Input";

// existing sizes set only the height, leaving the icon's own default width;
// `tight` squares it off so it matches the 16px icon the compact field expects
const ICON_SIZE = {
  xs: { height: 12 },
  sm: { height: 16 },
  md: { height: 20 },
  custom: { height: 24 },
  tight: { width: 16, height: 16 },
} satisfies Record<string, { width?: number; height: number }>;

export default function Searchbar({
  className,
  variant = "borderless",
  color = "transparent",
  size = "sm",
  ...props
}: Readonly<InputProps>) {
  return (
    <Input
      className={twMerge(
        "bg-tertiary/80 flex-1 rounded-lg border-transparent!",
        className,
      )}
      variant={variant}
      color={color}
      size={size}
      startContent={
        <SearchIcon {...ICON_SIZE[size ?? "sm"]} color="currentColor" />
      }
      type="search"
      autoComplete="off"
      data-1p-ignore
      data-lpignore="true"
      data-form-type="other"
      data-bwignore
      {...props}
    />
  );
}
